import React, { useContext } from 'react';

import { EnvDataSaver } from 'app/containers/EnvDataSaver';

import { FiltersContext } from './FiltersProvider';


export const LandingEnvDataSaver = () => {
    const { period } = useContext(FiltersContext);

    if (!period) return null;

    return <EnvDataSaver period={period} />;
};
